// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-panel-mantenimiento {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-mantenimiento {
  position: relative;
  justify-content: center;
  display: block;
  height: 98%;
  width: 94%;
  border-radius: 10px;
  box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15),
    0 6px 12px 0 rgba(24, 94, 224, 0.15);
  border: 2px solid #003757;
  border-radius: 10px;
}
.cont-mantenimiento-search {
  position: relative;
  height: 10%;
  width: 100%;
  /* background: rgba(195,195,195); */
  background: #003757;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px 5px 0px 0px;
}
.cont-search {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 25%;
}
.cont-search-space {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 55%;
}
.cont-search-buttons {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 20%;
}
.cont-mantenimiento-table {
  position: relative;
  height: 90%;
  width: 100%;
  /* background: rgba(195,195,195); */
  /* background: #003757; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-card-mantenimiento {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/****************************** tabla usuarios ******************************************/
.cont-table-mantenimiento {
  width: 99%;
  height: 99%;
  /* border: 1px solid #56575746; */
  border-radius: 5px;
  display: block;
  position: relative;
}
.head-table-mantenimiento {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  height: 7%;
  background-color: rgb(138, 138, 138);
  /* background:#4392c0; */
  /* border-bottom: 1px solid #003757; */
  border-radius: 5px 5px 0px 0px;
  font-size: 11px;
}
.field-head-table-mantenimiento {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: aliceblue;
  text-align: center;
}
.field-head-table-mantenimiento.field-nombre,
.field-head-table-mantenimiento.field-small {
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-small {
  width: 5%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.field-larger {
  width: 12%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-medium {
  width: 7%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.body-table-mantenimiento {
  width: 100%;
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  height: 90%;
  overflow: "auto";
}
.row-table-mantenimiento {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  color: #003757;
}
.row-table-mantenimiento:nth-child(odd) {
  background-color: #f8f9fa;
}
.row-table-mantenimiento:nth-child(even) {
  background-color: #eeeeee;
}
.field-body-table-mantenimiento {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: var(--font-size-xSmall);
  text-align: center;
  word-wrap: anywhere;
  overflow: auto ;
}
.field-body-table-mantenimiento:has(p:only-child:has(br)) {
  align-items: flex-start;
}
.row-table-mantenimiento:hover {
  /* background-color: #00375771; */
  background-color: #004e7ba4;
  cursor: pointer;
  color: aliceblue !important;
}
/* .field-body-table-mantenimiento.field-nombre,.field-body-table-mantenimiento.field-acciones{
    border-right: 1px solid #0037573a;
  } */
/****************************** tabla usuarios Config ******************************************/
.cont-table-mantenimiento-config {
  width: 98%;
  height: 99%;
  /* border: 1px solid #56575746; */
  border-radius: 5px;
  display: block;
  position: relative;
}
.head-table-mantenimiento-config {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10%;
  background-color: rgb(138, 138, 138);
  /* background:#4392c0; */
  /* border-bottom: 1px solid #003757; */
  border-radius: 5px 5px 0px 0px;
  font-size: 11px;
}
.field-head-table-mantenimiento-config {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: aliceblue;
  text-align: center;
}
.field-head-table-mantenimiento-config.field-nombre,
.field-head-table-mantenimiento-config.field-small {
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-small {
  width: 4%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.field-larger {
  width: 12%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}

.field-medium {
  width: 7%;
  border-right: 1px solid rgba(240, 248, 255, 0.473);
}
.body-table-mantenimiento-config {
  width: 100%;
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  height: 90%;
  overflow: "auto";
}
.row-table-mantenimiento-config {
  position: relative;
  display: flex;
  width: 100%;
  height: 40px;
  color: #003757;
}
.row-table-mantenimiento-config:nth-child(odd) {
  background-color: #f8f9fa;
}
.row-table-mantenimiento-config:nth-child(even) {
  background-color: #eeeeee;
}
.field-body-table-mantenimiento-config {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xSmall);
  text-align: center;
}
.row-table-mantenimiento-config:hover {
  background-color: #003757d3;
  cursor: pointer;
  color: aliceblue !important;
}
/* .field-body-table-mantenimiento-config.field-nombre,.field-body-table-mantenimiento-config.field-acciones{
  border-right: 1px solid #0037573a;
} */
.cont-img-field-acciones {
  position: relative;
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-field-acciones {
  position: relative;
  height: 70%;
}

.img-field-acciones:hover {
  transform: scale(1.1);
  transition: 0.3s;
}
.cont-load-user-list {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.cont-row-user-list {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.field-body-table-mantenimiento {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-size: small; */
}
.row-table-mantenimiento {
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 60px;
  color: #003757;
}
.row-table-mantenimiento:nth-child(odd) {
  background-color: #f8f9fa;
}
.row-table-mantenimiento:nth-child(even) {
  background-color: #eeeeee;
}
.field-body-table-mantenimiento {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-size: small; */
}
.row-table-mantenimiento:hover {
  background-color: #003757d3;
  cursor: pointer;
  color: aliceblue !important;
}

.form-msg-ok {
  color: #149209;
  position: absolute;
  left: 0;
  /* top:10% */
  bottom: 0%;
  background-color: rgba(211, 255, 217, 0.64);
  width: 99%;
  text-align: center;
  border: 2px solid #149209;
  border-radius: 5px;
}
.no-results {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: gray;
}
.pdf-download {
  position: absolute;
  width: 10%;
  left: 90%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-down-pdf {
  height: 70%;
}
.img-down-pdf:hover {
  height: 80%;
  cursor: pointer;
}

.txtCisCancelada {
  font-weight: bold;
  color: red;
}
.txtCisRechazada {
  font-weight: bold;
  color: red;
}
.txtCisCerrada {
  font-weight: bold;
  color: green;
}
.txtCisIniciada {
  font-weight: bold;
  color: #d9bb18;
}
.txtCisIniciado {
  font-weight: bold;
  color: #d9bb18;
}
.txtCisNo {
  font-weight: bold;
  color: #000000;
}
.txtCisPendiente {
  color: red;
}
.Tooltip-coment {
  position: absolute;
  width: 130%;
  /* min-width: 80%; */
  height: 80%;
  background-color: rgba(240, 248, 255, 0.793);
  border: 1px solid grey;
  border-radius: 10px;
  /* top:-10px; */
  color: rgb(68, 68, 68);
  left: 110%;
  z-index: 5;
  display: none;
  justify-content: center;
  align-items: center;
}

.field-status:hover .Tooltip-coment {
  display: flex;
}

.delteException:hover{
  width: 17%;

}
.btnAction:hover{
 width: 52% !important;
}`, "",{"version":3,"sources":["webpack://./src/components/respaldo-components/styles/PanelPortafolio.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB;wCACsC;EACtC,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yFAAyF;AACzF;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA;;KAEK;AACL,gGAAgG;AAChG;EACE,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,wBAAwB;EACxB,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA;;GAEG;AACH;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,2CAA2C;EAC3C,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,4CAA4C;EAC5C,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;;AAEZ;AACA;CACC,qBAAqB;AACtB","sourcesContent":[".main-panel-mantenimiento {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  background-color: transparent;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.content-mantenimiento {\r\n  position: relative;\r\n  justify-content: center;\r\n  display: block;\r\n  height: 98%;\r\n  width: 94%;\r\n  border-radius: 10px;\r\n  box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15),\r\n    0 6px 12px 0 rgba(24, 94, 224, 0.15);\r\n  border: 2px solid #003757;\r\n  border-radius: 10px;\r\n}\r\n.cont-mantenimiento-search {\r\n  position: relative;\r\n  height: 10%;\r\n  width: 100%;\r\n  /* background: rgba(195,195,195); */\r\n  background: #003757;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 5px 5px 0px 0px;\r\n}\r\n.cont-search {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 25%;\r\n}\r\n.cont-search-space {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 55%;\r\n}\r\n.cont-search-buttons {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 20%;\r\n}\r\n.cont-mantenimiento-table {\r\n  position: relative;\r\n  height: 90%;\r\n  width: 100%;\r\n  /* background: rgba(195,195,195); */\r\n  /* background: #003757; */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.content-card-mantenimiento {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/****************************** tabla usuarios ******************************************/\r\n.cont-table-mantenimiento {\r\n  width: 99%;\r\n  height: 99%;\r\n  /* border: 1px solid #56575746; */\r\n  border-radius: 5px;\r\n  display: block;\r\n  position: relative;\r\n}\r\n.head-table-mantenimiento {\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  height: 7%;\r\n  background-color: rgb(138, 138, 138);\r\n  /* background:#4392c0; */\r\n  /* border-bottom: 1px solid #003757; */\r\n  border-radius: 5px 5px 0px 0px;\r\n  font-size: 11px;\r\n}\r\n.field-head-table-mantenimiento {\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: aliceblue;\r\n  text-align: center;\r\n}\r\n.field-head-table-mantenimiento.field-nombre,\r\n.field-head-table-mantenimiento.field-small {\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.field-small {\r\n  width: 5%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n.field-larger {\r\n  width: 12%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.field-medium {\r\n  width: 7%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n.body-table-mantenimiento {\r\n  width: 100%;\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 90%;\r\n  overflow: \"auto\";\r\n}\r\n.row-table-mantenimiento {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 40px;\r\n  color: #003757;\r\n}\r\n.row-table-mantenimiento:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n.row-table-mantenimiento:nth-child(even) {\r\n  background-color: #eeeeee;\r\n}\r\n.field-body-table-mantenimiento {\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  font-size: var(--font-size-xSmall);\r\n  text-align: center;\r\n  word-wrap: anywhere;\r\n  overflow: auto ;\r\n}\r\n.field-body-table-mantenimiento:has(p:only-child:has(br)) {\r\n  align-items: flex-start;\r\n}\r\n.row-table-mantenimiento:hover {\r\n  /* background-color: #00375771; */\r\n  background-color: #004e7ba4;\r\n  cursor: pointer;\r\n  color: aliceblue !important;\r\n}\r\n/* .field-body-table-mantenimiento.field-nombre,.field-body-table-mantenimiento.field-acciones{\r\n    border-right: 1px solid #0037573a;\r\n  } */\r\n/****************************** tabla usuarios Config ******************************************/\r\n.cont-table-mantenimiento-config {\r\n  width: 98%;\r\n  height: 99%;\r\n  /* border: 1px solid #56575746; */\r\n  border-radius: 5px;\r\n  display: block;\r\n  position: relative;\r\n}\r\n.head-table-mantenimiento-config {\r\n  width: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 10%;\r\n  background-color: rgb(138, 138, 138);\r\n  /* background:#4392c0; */\r\n  /* border-bottom: 1px solid #003757; */\r\n  border-radius: 5px 5px 0px 0px;\r\n  font-size: 11px;\r\n}\r\n.field-head-table-mantenimiento-config {\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: aliceblue;\r\n  text-align: center;\r\n}\r\n.field-head-table-mantenimiento-config.field-nombre,\r\n.field-head-table-mantenimiento-config.field-small {\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.field-small {\r\n  width: 4%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n.field-larger {\r\n  width: 12%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n\r\n.field-medium {\r\n  width: 7%;\r\n  border-right: 1px solid rgba(240, 248, 255, 0.473);\r\n}\r\n.body-table-mantenimiento-config {\r\n  width: 100%;\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 90%;\r\n  overflow: \"auto\";\r\n}\r\n.row-table-mantenimiento-config {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 40px;\r\n  color: #003757;\r\n}\r\n.row-table-mantenimiento-config:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n.row-table-mantenimiento-config:nth-child(even) {\r\n  background-color: #eeeeee;\r\n}\r\n.field-body-table-mantenimiento-config {\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: var(--font-size-xSmall);\r\n  text-align: center;\r\n}\r\n.row-table-mantenimiento-config:hover {\r\n  background-color: #003757d3;\r\n  cursor: pointer;\r\n  color: aliceblue !important;\r\n}\r\n/* .field-body-table-mantenimiento-config.field-nombre,.field-body-table-mantenimiento-config.field-acciones{\r\n  border-right: 1px solid #0037573a;\r\n} */\r\n.cont-img-field-acciones {\r\n  position: relative;\r\n  width: 50%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.img-field-acciones {\r\n  position: relative;\r\n  height: 70%;\r\n}\r\n\r\n.img-field-acciones:hover {\r\n  transform: scale(1.1);\r\n  transition: 0.3s;\r\n}\r\n.cont-load-user-list {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.cont-row-user-list {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n}\r\n.field-body-table-mantenimiento {\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* font-size: small; */\r\n}\r\n.row-table-mantenimiento {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 60px;\r\n  color: #003757;\r\n}\r\n.row-table-mantenimiento:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n.row-table-mantenimiento:nth-child(even) {\r\n  background-color: #eeeeee;\r\n}\r\n.field-body-table-mantenimiento {\r\n  position: relative;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* font-size: small; */\r\n}\r\n.row-table-mantenimiento:hover {\r\n  background-color: #003757d3;\r\n  cursor: pointer;\r\n  color: aliceblue !important;\r\n}\r\n\r\n.form-msg-ok {\r\n  color: #149209;\r\n  position: absolute;\r\n  left: 0;\r\n  /* top:10% */\r\n  bottom: 0%;\r\n  background-color: rgba(211, 255, 217, 0.64);\r\n  width: 99%;\r\n  text-align: center;\r\n  border: 2px solid #149209;\r\n  border-radius: 5px;\r\n}\r\n.no-results {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: gray;\r\n}\r\n.pdf-download {\r\n  position: absolute;\r\n  width: 10%;\r\n  left: 90%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.img-down-pdf {\r\n  height: 70%;\r\n}\r\n.img-down-pdf:hover {\r\n  height: 80%;\r\n  cursor: pointer;\r\n}\r\n\r\n.txtCisCancelada {\r\n  font-weight: bold;\r\n  color: red;\r\n}\r\n.txtCisRechazada {\r\n  font-weight: bold;\r\n  color: red;\r\n}\r\n.txtCisCerrada {\r\n  font-weight: bold;\r\n  color: green;\r\n}\r\n.txtCisIniciada {\r\n  font-weight: bold;\r\n  color: #d9bb18;\r\n}\r\n.txtCisIniciado {\r\n  font-weight: bold;\r\n  color: #d9bb18;\r\n}\r\n.txtCisNo {\r\n  font-weight: bold;\r\n  color: #000000;\r\n}\r\n.txtCisPendiente {\r\n  color: red;\r\n}\r\n.Tooltip-coment {\r\n  position: absolute;\r\n  width: 130%;\r\n  /* min-width: 80%; */\r\n  height: 80%;\r\n  background-color: rgba(240, 248, 255, 0.793);\r\n  border: 1px solid grey;\r\n  border-radius: 10px;\r\n  /* top:-10px; */\r\n  color: rgb(68, 68, 68);\r\n  left: 110%;\r\n  z-index: 5;\r\n  display: none;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.field-status:hover .Tooltip-coment {\r\n  display: flex;\r\n}\r\n\r\n.delteException:hover{\r\n  width: 17%;\r\n\r\n}\r\n.btnAction:hover{\r\n width: 52% !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
